export const storyContentIdPrefix = 'storyContent-';
export const pageBreakClassName = 'setup-pdf-page-break';
export const HEADER_FOOTER_ZOOM_FACTOR = 0.52;
export const SECTION_ZOOM_FACTOR = 0.75;
export const SECTION_PADDING_FACTOR = '1in';